export const ALLOWED_UPLOAD_EXTENSIONS = ['.wav', '.mp3', '.mp4', '.m4a'];

export const ALLOWED_UPLOAD_MIME_TYPES = [
  'audio/mpeg',
  'audio/mp3',
  'audio/wav',
  'audio/x-wav',
  'audio/mp4',
  'audio/m4a',
  'audio/x-m4a',
  'video/mp4',
];

const hasAllowedExtension = (fileName) => {
  const lower = fileName.toLowerCase();
  return ALLOWED_UPLOAD_EXTENSIONS.some((ext) => lower.endsWith(ext));
};

export const validateUploadFile = (file) => {
  if (!file) {
    return { valid: false, error: 'Please select a file to upload.' };
  }

  if (file.size === 0) {
    return { valid: false, error: 'This file is empty. Choose a recording with audio content.' };
  }

  const mimeOk = ALLOWED_UPLOAD_MIME_TYPES.includes(file.type);
  const extOk = hasAllowedExtension(file.name);

  if (!mimeOk && !extOk) {
    return {
      valid: false,
      error: 'Unsupported format. Use WAV, MP3, MP4, or M4A.',
    };
  }

  const maxSize = 500 * 1024 * 1024;
  if (file.size > maxSize) {
    return { valid: false, error: 'File size must be less than 500MB.' };
  }

  return { valid: true, error: null };
};

export const appendRecordingMetadata = (formData, {
  caseReference,
  language,
  languageMarkers = [],
  sourceType,
}) => {
  if (caseReference) {
    formData.append('case_reference', caseReference);
  }
  if (language) {
    formData.append('language', language);
  }
  if (sourceType) {
    formData.append('source_type', sourceType);
  }
  if (languageMarkers.length > 0) {
    formData.append('language_markers', JSON.stringify(languageMarkers));
  }
  return formData;
};

export const extractDuplicateSession = (error) => {
  const data = error?.response?.data;
  if (!data) return null;

  if (!(data.duplicate || data.is_duplicate || data.code === 'duplicate')) {
    return null;
  }

  return {
    id: data.existing_upload_id || data.existing_audio_asset_id || data.existing_id || data.transcription_id,
    title: data.existing_title || data.message || data.error || 'Existing recording',
  };
};

export const formatSessionTimestamp = (date) => {
  if (!date) return '—';
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
};

export const formatRecordingTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const buildUploadFormData = ({
  audioBlob,
  fileName,
  title,
  duration,
  caseRef,
  language,
  markers,
  sourceType,
}) => {
  const formData = new FormData();
  formData.append('audio', audioBlob, fileName);
  formData.append('duration', duration.toString());
  formData.append('title', title);
  appendRecordingMetadata(formData, {
    caseReference: caseRef,
    language,
    languageMarkers: markers,
    sourceType,
  });
  return formData;
};
